import en from './en'
import ptBR from './pt-BR'
import sp from './sp'

export default {
  'pt-BR': ptBR,
  en,
  sp
}
